/** Tiny inline showcase of up to 3 achievement badges next to a user's name. */
export default function AuthorBadges({ badges, size = "sm", testid }) {
  if (!badges?.length) return null;
  return (
    <span className={`inline-flex items-center gap-0.5 ml-1 align-middle ${size === "xs" ? "text-[11px]" : "text-sm"}`} data-testid={testid}>
      {badges.slice(0, 3).map((b) => (
        <span key={b.key} title={b.title} className="leading-none cursor-help" data-testid={`author-badge-${b.key}`}>{b.icon}</span>
      ))}
    </span>
  );
}
